import React from "react";
import "~/less/web-internal.less";
import { cls } from "cls";
import { withUserAndChat } from "~/common/Store/connectUserAndChat";
import { User } from "~/common/Store/models/User";
import { useInternalNotes } from "./hooks/useInternalNotes";

interface InternalNotesButtonProps {
  categoryId: number;
  user: User;
}

export const defaultInternalNotesData = {
  categoryId: 0,
  link: "",
};

const InternalNotesButton = ({
  categoryId,
  user,
}: InternalNotesButtonProps) => {
  const isInternal =
    user.analyticsData?.is_on_vpn?.toLocaleUpperCase() === "YES";

  const internalNotesData = useInternalNotes(categoryId, isInternal);

  return internalNotesData.categoryId && internalNotesData.link ? (
    <a
      type="button"
      href={internalNotesData.link}
      target="_blank"
      rel="noopener noreferrer"
      id="web-internal-trigger"
      className={cls(
        "fixed bottom-2.5 right-2.5 z-1000 max-w-[120px]",
        "group flex items-center px-[7px] py-[7px] text-[#686b66] font-normal",
        "rounded [box-shadow:0_1px_4px_rgba(0,0,0,0.3)] cursor-pointer leading-none",
        "bg-white",
      )}
      data-testid="show-internal-notes-button"
    >
      <i className={cls("icon-attention mr-[7px] text-[21px] text-red-500")} />
      <span
        className={cls(
          "webinfo-trigger__text",
          "text-sm-1/2",
          "group-hover:text-[#333]",
        )}
      >
        {" "}
        Category Internal Notes
      </span>
    </a>
  ) : null;
};

export default withUserAndChat(InternalNotesButton);
